import React from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import cleanObj from 'utils/cleanObj';
import FilteredListing from './index';

// Script to initialise Filter Listing React component on all .listing-app elements
$('.listing-app').each(function () {
    const appID = $(this).data('app-id');
    const $apiDataDiv = $(`.${appID}-api-json`);

    // Early return if div target is not specified
    if (!appID || !$apiDataDiv.length) { return; }

    // Setup props
    const props = {
        url: $apiDataDiv.data('api-url'),
        rawData: $apiDataDiv.html(),
        listingIdentifier: appID,
        itemType: $apiDataDiv.data('tile-type'),
        itemDirection: $apiDataDiv.data('tile-direction'),
        itemContainerLayout: $apiDataDiv.data('tile-container-layout'),
        filtersLayout: $apiDataDiv.data('filters-layout')
    };

    // Remove any empty prop settings to let the default prop values kick in
    cleanObj(props);

    ReactDOM.render(
        React.createElement(FilteredListing, props, null),
        $(this)[0]
    );
});
